import React, { useRef, useState } from 'react';
import { ArrowUpTrayIcon, DocumentTextIcon, XMarkIcon } from '@heroicons/react/24/outline';

export default function FileDropzone({ onFileSelect, acceptedTypes = '*' }) {
  const inputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [dragging, setDragging] = useState(false);

  const handleFile = (file) => {
    if (!file) return;
    setSelectedFile(file);
    onFileSelect(file);
  };

  const handleChange = (e) => {
    handleFile(e.target.files[0]);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    handleFile(e.dataTransfer.files[0]);
  };

  const handleRemove = (e) => {
    e.stopPropagation();
    setSelectedFile(null);
    onFileSelect(null);
    if (inputRef.current) inputRef.current.value = '';
  };

  const formatSize = (bytes) => {
    if (bytes < 1024) return `${bytes} o`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} Ko`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} Mo`;
  };

  return (
    <div
      onClick={() => !selectedFile && inputRef.current?.click()}
      onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
      onDragLeave={() => setDragging(false)}
      onDrop={handleDrop}
      className={`relative border-2 border-dashed rounded-lg p-4 transition-colors
        ${selectedFile
          ? 'border-indigo-300 bg-indigo-50 cursor-default'
          : dragging
            ? 'border-indigo-400 bg-indigo-50 cursor-pointer'
            : 'border-gray-300 bg-gray-50 hover:border-indigo-400 hover:bg-indigo-50 cursor-pointer'
        }`}
    >
      <input
        ref={inputRef}
        type="file"
        accept={acceptedTypes}
        onChange={handleChange}
        className="hidden"
      />

      {selectedFile ? (
        <div className="flex items-center gap-3">
          <DocumentTextIcon className="h-8 w-8 text-indigo-500 flex-shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-gray-900 truncate">{selectedFile.name}</p>
            <p className="text-xs text-gray-500">{formatSize(selectedFile.size)}</p>
          </div>
          <button
            type="button"
            onClick={handleRemove}
            className="p-1 rounded-full hover:bg-indigo-100 text-gray-400 hover:text-red-500 transition-colors"
            title="Retirer le fichier"
          >
            <XMarkIcon className="h-4 w-4" />
          </button>
        </div>
      ) : (
        <div className="flex flex-col items-center gap-2 py-2 text-center">
          <ArrowUpTrayIcon className="h-8 w-8 text-gray-400" />
          <p className="text-sm text-gray-600">
            <span className="font-medium text-indigo-600">Cliquez pour choisir</span> ou glissez-déposez
          </p>
          <p className="text-xs text-gray-400">{acceptedTypes.replace(/\./g, '').toUpperCase().replace(/,/g, ', ')}</p>
        </div>
      )}
    </div>
  );
}
